import { ValueObject } from '../shared/ValueObject';
import type { ErrorDisplayItem } from '@/features/panels/constants/panelDetailTab.constants';

// ========== 型定義 ==========

interface ErrorFlagStatusValueProps {
  readonly displayName: string;
  readonly isActive: boolean;
  readonly errorCode: number | null;
}

// ========== 値オブジェクト ==========

/**
 * エラーフラグ状態の値オブジェクト
 *
 * エラーフラグの表示名・アクティブ状態を不変に保持する。
 * 生成時に完全な状態であり、変更は新インスタンス生成で対応。
 */
export class ErrorFlagStatusValue extends ValueObject<ErrorFlagStatusValueProps> {
  private constructor(props: ErrorFlagStatusValueProps) {
    super(props);
  }

  /**
   * ErrorFlagStatusValueを生成
   */
  public static create(props: ErrorFlagStatusValueProps): ErrorFlagStatusValue {
    return new ErrorFlagStatusValue({
      displayName: props.displayName,
      isActive: props.isActive,
      errorCode: props.errorCode,
    });
  }

  public getDisplayName(): string {
    return this.value.displayName;
  }

  public getIsActive(): boolean {
    return this.value.isActive;
  }

  /**
   * プレゼンテーションモデルに変換
   */
  public toPresentationModel(): ErrorDisplayItem {
    return {
      name: this.value.displayName,
      isActive: this.value.isActive,
      errorCode: this.value.errorCode,
    };
  }
}
